if (!customElements.get('ihn-floor-quote')) {
  customElements.define('ihn-floor-quote', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-floor-config]').textContent);
      this.current = 'area';
      this.money = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
      this.number = new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 2 });
      this.querySelector('[data-floor-next]').addEventListener('click', () => this.next());
      this.querySelector('[data-floor-prev]').addEventListener('click', () => this.previous());
      this.querySelector('[data-floor-callback]').addEventListener('click', () => {
        this.dispatchEvent(new CustomEvent('ihn-floor-callback', { bubbles: true }));
      });
      this.addEventListener('change', e => {
        if (e.target.name === 'vloer_type') {
          this.querySelectorAll('[data-plak-only]').forEach(input => {
            const allowed = this.value('vloer_type') === 'plak';
            input.closest('label').hidden = !allowed;
            input.disabled = !allowed;
            if (!allowed) input.checked = false;
          });
        }
        if (e.target.name === 'vloer_voorbereiden' && this.value('vloer_voorbereiden') === 'no') this.clear('vloer_voorbereiding');
        if (e.target.name === 'vloer_plinten' && this.value('vloer_plinten') === 'no') {
          this.clear('vloer_plint_maat');
          this.querySelector('[name="vloer_plint_meters"]').value = '';
        }
        this.querySelector('[data-pattern-note]').hidden = !['tile', 'chevron', 'special'].includes(this.value('vloer_patroon'));
        this.error('');
      });
      this.addEventListener('input', () => this.error(''));
      this.addEventListener('keydown', e => {
        if (e.key === 'Enter' && e.target.matches('input[type="text"]')) { e.preventDefault(); this.next(); }
      });
      this.querySelectorAll('[data-rate]').forEach(el => el.textContent = this.t('per_m2', { price: this.money.format(this.materialRate(el.dataset.rate)) }));
      this.querySelectorAll('[data-pattern-rate]').forEach(el => el.textContent = this.t('install_rate', { price: this.money.format(this.patternRate(el.dataset.patternRate)) }));
      this.querySelectorAll('[data-prep-rate]').forEach(el => el.textContent = this.t('per_m2', { price: this.money.format(this.rate(el.dataset.prepRate + '_rate')) }));
      this.querySelectorAll('[data-skirting-rate]').forEach(el => el.textContent = this.t('per_m', { price: this.money.format(this.rate('skirting_base') + Number(el.dataset.skirtingRate)) }));
      this.show('area', false);
    }
    t(key, replacements = {}) {
      return Object.entries(replacements).reduce((s, [k, v]) => s.replaceAll('{' + k + '}', String(v)), this.config.text[key] || key);
    }
    rate(key) { return Number(this.config.rates[key]); }
    value(name) { return this.querySelector('[name="' + name + '"]:checked')?.value || ''; }
    clear(name) { this.querySelectorAll('[name="' + name + '"]').forEach(input => input.checked = false); }
    decimal(name) {
      const v = this.querySelector('[name="' + name + '"]').value.trim();
      if (!/^\d+(?:[.,]\d{1,2})?$/.test(v)) return NaN;
      return Number(v.replace(',', '.'));
    }
    materialRate(type) { return this.rate(type === 'hout' ? 'wood_price' : type === 'laminaat' ? 'laminate_price' : 'pvc_price'); }
    patternRate(pattern) { return this.rate(pattern + '_rate'); }
    flow() {
      return ['area', 'type', 'pattern', 'prep', ...(this.value('vloer_voorbereiden') === 'yes' ? ['prep_type'] : []), 'skirting', ...(this.value('vloer_plinten') === 'yes' ? ['skirting_type', 'skirting_length'] : []), 'result'];
    }
    error(message) {
      const el = this.querySelector('[data-floor-error]');
      el.textContent = message;
      el.classList.toggle('is-visible', Boolean(message));
    }
    valid(step) {
      if (step === 'area' || step === 'skirting_length') {
        const n = this.decimal(step === 'area' ? 'vloer_oppervlakte' : 'vloer_plint_meters');
        return Number.isFinite(n) && n >= 0.1 && n <= 10000;
      }
      const fields = { type: 'vloer_type', pattern: 'vloer_patroon', prep: 'vloer_voorbereiden', prep_type: 'vloer_voorbereiding', skirting: 'vloer_plinten', skirting_type: 'vloer_plint_maat' };
      return step === 'result' || Boolean(this.value(fields[step]));
    }
    validateAll() {
      const invalid = this.flow().find(step => !this.valid(step));
      if (invalid) { this.show(invalid); this.error(this.t(invalid === 'area' ? 'error_area' : invalid === 'skirting_length' ? 'error_length' : 'error_choice')); return false; }
      return true;
    }
    next() {
      if (!this.valid(this.current)) {
        this.error(this.t(this.current === 'area' ? 'error_area' : this.current === 'skirting_length' ? 'error_length' : 'error_choice'));
        this.querySelector('[data-floor-step="' + this.current + '"] input')?.focus({ preventScroll: true });
        return;
      }
      const flow = this.flow();
      const next = flow[flow.indexOf(this.current) + 1];
      if (next) this.show(next);
    }
    previous() {
      if (this.current === 'area') { this.dispatchEvent(new CustomEvent('ihn-floor-category', { bubbles: true })); return; }
      const flow = this.flow();
      this.show(flow[flow.indexOf(this.current) - 1]);
    }
    show(step, focus = true) {
      this.current = step;
      this.querySelectorAll('[data-floor-step]').forEach(el => el.hidden = el.dataset.floorStep !== step);
      this.error('');
      const main = step.startsWith('prep') ? 'prep' : step.startsWith('skirting') ? 'skirting' : step;
      const number = ['area', 'type', 'pattern', 'prep', 'skirting', 'result'].indexOf(main) + 1;
      this.querySelector('[data-floor-progress]').textContent = this.t('step', { current: number, label: this.t('step_' + main) });
      const progress = this.querySelector('[role="progressbar"]');
      progress.setAttribute('aria-valuenow', number);
      progress.setAttribute('aria-valuetext', this.t('step', { current: number, label: this.t('step_' + main) }));
      progress.firstElementChild.style.width = number / 6 * 100 + '%';
      const next = this.querySelector('[data-floor-next]');
      next.hidden = step === 'result';
      const flow = this.flow();
      next.textContent = this.t(flow[flow.indexOf(step) + 1] === 'result' ? 'see_price' : 'next') + ' →';
      this.querySelector('[data-floor-prev]').textContent = '← ' + this.t(step === 'area' ? 'category' : step === 'result' ? 'edit' : 'prev');
      if (step === 'pattern') this.querySelectorAll('[data-plak-only]').forEach(input => { input.closest('label').hidden = this.value('vloer_type') !== 'plak'; });
      if (step === 'prep_type') this.querySelector('[data-compatibility]').textContent = this.t(this.value('vloer_type') === 'plak' ? 'compat_plak' : this.value('vloer_type') === 'click' ? 'compat_click' : 'compat_other');
      if (step === 'result') this.renderResult();
      if (focus) {
        this.querySelector('[data-floor-step="' + step + '"] h2').focus({ preventScroll: true });
        this.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      }
    }
    calculate() {
      const area = this.decimal('vloer_oppervlakte');
      const type = this.value('vloer_type');
      const pattern = this.value('vloer_patroon');
      const waste = this.rate(['straight', 'tile'].includes(pattern) ? 'straight_waste' : 'pattern_waste');
      const quantity = Math.ceil((area * (1 + waste / 100) - 0.000000001) * 100) / 100;
      const materialRate = this.materialRate(type);
      const installationRate = this.patternRate(pattern);
      const prep = this.value('vloer_voorbereiden') === 'yes' ? this.value('vloer_voorbereiding') : '';
      const prepRate = prep ? this.rate(prep + '_rate') : 0;
      const skirting = this.value('vloer_plinten') === 'yes';
      const size = ['70 × 12', '70 × 15', '90 × 12', '90 × 15', '120 × 12', '120 × 15'][Number(this.value('vloer_plint_maat'))];
      const length = skirting ? this.decimal('vloer_plint_meters') : 0;
      const skirtingRate = skirting ? this.rate('skirting_base') + Number(this.value('vloer_plint_maat')) : 0;
      const cents = n => Math.round((n + Number.EPSILON) * 100);
      const amounts = [cents(quantity * materialRate), cents(area * installationRate), cents(area * prepRate), cents(length * skirtingRate)];
      const total = amounts.reduce((a, b) => a + b, 0) / 100;
      return { area, type, pattern, waste, quantity, materialRate, installationRate, prep, prepRate, skirting, size, length, skirtingRate, amounts: amounts.map(n => n / 100), total };
    }
    selections(c) {
      return [
        [this.t('area_label'), this.t('area_value', { area: this.number.format(c.area) })],
        [this.t('type_label'), this.t('type_' + c.type)],
        [this.t('pattern_label'), this.t('pattern_' + c.pattern)],
        [this.t('prep_type_label'), c.prep ? this.t('prep_' + c.prep) : this.t('none')],
        [this.t('skirting_label'), c.skirting ? this.t('skirting_value', { size: c.size, length: this.number.format(c.length) }) : this.t('none')]
      ];
    }
    costs(c) {
      const rows = [
        [this.t('materials'), this.t('material_detail', { quantity: this.number.format(c.quantity), price: this.money.format(c.materialRate), waste: c.waste }), c.amounts[0]],
        [this.t('installation', { pattern: this.t('pattern_' + c.pattern) }), this.t('installation_detail', { area: this.number.format(c.area), price: this.money.format(c.installationRate) }), c.amounts[1]]
      ];
      if (c.prep) rows.push([this.t('prep_' + c.prep), this.t('prep_detail', { area: this.number.format(c.area), price: this.money.format(c.prepRate) }), c.amounts[2]]);
      if (c.skirting) rows.push([this.t('skirting_row', { size: c.size }), this.t('skirting_detail', { length: this.number.format(c.length), price: this.money.format(c.skirtingRate) }), c.amounts[3]]);
      return rows;
    }
    estimateNote(c) {
      return this.t('estimate_note', { waste: c.waste });
    }
    summary() {
      if (this.flow().some(s => !this.valid(s))) return [];
      const c = this.calculate();
      return [...this.selections(c), [this.t('waste'), c.waste + '%'], ...this.costs(c).map(([label, detail, price]) => [label, detail + ' = ' + this.money.format(price)]), [this.t('indicative_price'), this.money.format(c.total)], [this.t('total_help'), this.estimateNote(c) + ' ' + this.t('estimate_help')]];
    }
    renderResult() {
      const c = this.calculate();
      this.querySelector('[data-floor-total]').textContent = '≈ ' + this.money.format(c.total);
      const selections = this.querySelector('[data-floor-selections]');
      selections.replaceChildren();
      this.selections(c).forEach(([label, value]) => {
        const row = document.createElement('div');
        const term = document.createElement('dt'); term.textContent = label;
        const definition = document.createElement('dd'); definition.textContent = value;
        row.append(term, definition); selections.append(row);
      });
      const costs = this.querySelector('[data-floor-breakdown]');
      costs.replaceChildren();
      this.costs(c).forEach(([label, detail, amount]) => {
        const row = document.createElement('div');
        const description = document.createElement('div');
        const title = document.createElement('b'); title.textContent = label;
        const note = document.createElement('small'); note.textContent = detail;
        const price = document.createElement('strong'); price.textContent = this.money.format(amount);
        description.append(title, note); row.append(description, price); costs.append(row);
      });
      this.querySelector('[data-floor-estimate-note]').textContent = this.estimateNote(c);
      const showroom = this.querySelector('[data-floor-showroom]');
      const url = new URL(showroom.getAttribute('href'), location.origin);
      const theme = new URLSearchParams(location.search).get('preview_theme_id');
      if (theme) url.searchParams.set('preview_theme_id', theme);
      showroom.href = url.pathname + url.search;
    }
  });
}
